import styled, {keyframes} from "styled-components"

export const Background = styled.div`

   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: #f1a9ca;
   min-height: 100px;

`

export const Logo = styled.img`
    max-width: 1000px;
    align-self: center;
    @media (max-width: 1000px) {
        max-width: 700px;
    }
     @media (max-width: 767px) {
        max-width: 80%;
    }
`
export const Paragraph = styled.p`
    text-align: center;
    font-size: 3rem;
    font-family: 'KiwiSoda';
    color: #420942;
     @media (max-width: 767px) {
        font-size: 2rem;
    }
    

`
export const Pinky = styled.div`
    background-color: #f1a9ca;
    min-height: 100px;
`